module.exports = __webpack_public_path__ + "img/pn.9533d32a.svg";